// src/categoriesSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { categoriesApi } from '../../services/categories';

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(categoriesApi.endpoints.getAllCategories.matchFulfilled, (state, action) => {
      state.categories = action.payload;
    });
  },
});

export const { setCategories } = categoriesSlice.actions;

export default categoriesSlice.reducer;
